export * from './lib/cookies-banner.component.module';
